export const REAGENT_BRAND_OPTIONS = [
  '阿拉丁',
  '麦克林',
  '毕得',
  '宝莱特',
  '探索',
  '乐研',
  '安耐吉',
  '百灵威',
  'TCI',
  'sigma',
  'alfa',
  '苏州励为',
  'greatcell',
  'MCE',
  '其他品牌代购'
] as const;

export const getReagentBrandOptions = (currentValue?: string): string[] => {
  const legacyValue = String(currentValue || '').trim();
  if (!legacyValue || REAGENT_BRAND_OPTIONS.includes(legacyValue as typeof REAGENT_BRAND_OPTIONS[number])) {
    return [...REAGENT_BRAND_OPTIONS];
  }
  return [legacyValue, ...REAGENT_BRAND_OPTIONS];
};
